module.exports = __webpack_public_path__ + "img/report-6.f8b1c76b.jpg";